import React, { useMemo } from "react";
import StackedTrendChart from "../../CHARTS/StackedTrendChart";

const STACK_KEYS = [
  "HQ_NORMAL_OCCURENCE",
  "HQ_PR_22_HR_OCCURENCE",
  "HQ_PR_30_HRS_OCCURENCE",
  "HQ_PR>30_HRS_OCCURENCE",
  "HQ_CREW_REST_AT_OUT_STATION_LOBBY_OCCURANCE",
  "HQ_CREW_REST_AT_OUT_STATION_NON_LOBBY_OCCURANCE",
  "OUT_STN_CREW_AT_HQ_REST_OCCURENCE",
];
const STACK_KEYS2 = [
  "HQ_NORMAL",
  "HQ_PR_22_HR",
  "HQ_PR_30_HRS",
  "HQ_PR>30_HRS",
  "HQ_CREW_REST_AT_OUT_STATION_LOBBY",
  "HQ_CREW_REST_AT_OUT_STATION_NON_LOBBY",
  "OUT_STN_CREW_AT_HQ_REST",
];

const CrewAvgOccChart = ({ data = [], setSelectedLineBar }) => {
  const groupedData = useMemo(() => {
    if (!data.length) return [];

    const cleaned = data.filter((row) => row?.Lobby?.trim() !== "[TOTAL]");

    const grouped = cleaned.reduce((acc, row) => {
      if (!acc[row.Lobby]) {
        acc[row.Lobby] = { Lobby: row.Lobby };
      }
      STACK_KEYS.forEach((key) => {
        acc[row.Lobby][
          key.replace("_OCCURENCE", "").replace("_OCCURANCE", "")
        ] =
          (acc[row.Lobby][
            key.replace("_OCCURENCE", "").replace("_OCCURANCE", "")
          ] || 0) + Number(row[key] || 0);
      });

      return acc;
    }, {});

    // Convert to array
    const result = Object.values(grouped);
    // Add total for sorting
    const withTotal = result.map((row) => {
      const total = STACK_KEYS2.reduce(
        (sum, key) => sum + Number(row[key] || 0),
        0,
      );

      return { ...row, __total: total };
    });

    // Sort highest → lowest
    return withTotal.sort((a, b) => b.__total - a.__total);
  }, [data]);

  return (
    <div className="newUiBody mt-3 col-md-12">
      <h5 className="text-center mb-3">Lobby Wise Occurrence Distribution</h5>

      <StackedTrendChart
        data={groupedData}
        xKey="Lobby"
        setSelectedLineBar={setSelectedLineBar}
        stackKeys={STACK_KEYS2}
      />
    </div>
  );
};

export default CrewAvgOccChart;
